// Cart Drawer Progress Bar js

document.addEventListener("DOMContentLoaded", updateProgressBar);

document.addEventListener('click', async (event) => {
    const btn = event.target.closest('.add-to-cart-btn');
    if (!btn) return; // Exit if it's not the button

    event.preventDefault(); // Prevent default behavior only for the button

    // Get variant ID from form input
    const formInput = btn.closest('.itgProduct-card__form')?.querySelector('input[name="id"]');
    if (!formInput) return;

    const variantId = formInput.getAttribute('value');
    if (!variantId) return;

    // Add product to cart
    await addProductToCart(variantId, 1);

    const accordion = btn.closest('.main_free_product_accordion_wrapper');

    // Remove only the single product wrapper
    const productWrapper = btn.closest('.single_step_product_wrapper');
    if (productWrapper) productWrapper.remove();

    // If no more products remain, remove the entire Free Products accordion
    if (accordion && accordion.querySelectorAll('.single_step_product_wrapper').length === 0) {
        accordion.remove();
    }
});


    function newUpdateCartDrawer(){

                        const cartWrapper = document.querySelector('#site-cart-sidebar .cart-form');
                        const mainCartWrapper = document.querySelector('.template-cart .cart-section');

                        const checkEligibilityInLocalStorage = () => {
                            const eligibility = localStorage.getItem('eligibility');
                            return eligibility?.toLowerCase() === 'true' ? true
                                : eligibility?.toLowerCase() === 'false' ? false
                                : null;
                        };                    

                        const toggleAssemblyInCart = (isEligible) => {

                            if (cartWrapper) cartWrapper.classList.toggle('hide_assembly_variants', !isEligible);
                            if (mainCartWrapper) mainCartWrapper.classList.toggle('hide_assembly_variants', !isEligible);

                            // Get main wrappers (safely)
                            const mainCartDrawerWrapper = cartWrapper?.querySelector(".cart__items");
                            const mainCartPageWrapper = mainCartWrapper?.querySelector(".cart-form__items");

                            let hasAssemblyMessage = false;

                            // --- Process main cart page items ---
                            if (mainCartPageWrapper) {
                                const itemWrappers = mainCartPageWrapper.querySelectorAll('.cart-form-item');

                                itemWrappers.forEach(wrapper => {
                                    const title = (wrapper.dataset.title || "").toLowerCase();

                                    if (title.includes("assembly services")) {
                                        if (!isEligible) {
                                            if (!wrapper.querySelector('.assembly-service-msg')) {
                                                const msg = document.createElement('p');
                                                msg.className = 'assembly-service-msg';
                                                msg.textContent = "Assembly service isn’t offered in your selected location. To proceed with checkout, please remove this item from your cart.";
                                                wrapper.appendChild(msg);
                                            }
                                            hasAssemblyMessage = true;
                                        } else {
                                            const existingMsg = wrapper.querySelector('.assembly-service-msg');
                                            if (existingMsg) existingMsg.remove();
                                        }
                                    }
                                });
                            }

                            // --- Process cart drawer items ---
                            if (mainCartDrawerWrapper) {
                                const itemWrappers = mainCartDrawerWrapper.querySelectorAll('.itg_cart_item_wrapper');

                                itemWrappers.forEach(wrapper => {
                                    const cartItem = wrapper.querySelector('.cart-item');
                                    if (!cartItem) return;

                                    const title = (cartItem.dataset.title || "").toLowerCase();

                                    if (title.includes("assembly services")) {
                                        if (!isEligible) {
                                            if (!wrapper.querySelector('.assembly-service-msg')) {
                                                const msg = document.createElement('p');
                                                msg.className = 'assembly-service-msg';
                                                // msg.textContent = "It is no longer valid for the updated location";
                                                msg.textContent = "Assembly service isn’t offered in your selected location. To proceed with checkout, please remove this item from your cart.";
                                                wrapper.appendChild(msg);
                                            }
                                            hasAssemblyMessage = true;
                                        } else {
                                            const existingMsg = wrapper.querySelector('.assembly-service-msg');
                                            if (existingMsg) existingMsg.remove();
                                        }
                                    }
                                });
                            }

                            // --- Disable all checkout buttons if needed ---
                            const checkoutBtns = document.querySelectorAll('button#CheckOut');
                            checkoutBtns.forEach(btn => {
                                btn.disabled = hasAssemblyMessage;
                                btn.style.opacity = hasAssemblyMessage ? 0.5 : 1;
                                btn.style.pointerEvents = hasAssemblyMessage ? 'none' : 'auto';
                            });
                        };

                        setTimeout(() => {
                            toggleAssemblyInCart(checkEligibilityInLocalStorage());
                        }, 500);
                        
						const subTotalElem = document.getElementById('AjaxCartSubtotal');
						if (!subTotalElem) return;

						let subTotalAmt = subTotalElem.querySelector('.cart__total')?.getAttribute("data-total-price");
						if (!subTotalAmt) return;

					
						let cartPrice = parseFloat(subTotalAmt.replace(/,/g, '').trim());

						const mainProgressWrapper = document.querySelector('.cart_drawer_progress_bar_inner_wrapper');
						if (!mainProgressWrapper) return;

						const cartBar = mainProgressWrapper.querySelector(".cart_drawer_progress_bar");
						if (!cartBar) return;

						const maxAmountPrice = parseFloat(cartBar.getAttribute("data-maxamt"));
						if (isNaN(maxAmountPrice) || maxAmountPrice <= 0) return;

						(async () => {
							// Fetch current cart
							const cartResponse = await fetch('/cart.js');
							const cart = await cartResponse.json();

							let allProductsHTML = '';

							const mainProgressWrapper = document.querySelector('.cart_drawer_progress_bar_inner_wrapper');
							if (!mainProgressWrapper) return;

							const cartBar = mainProgressWrapper.querySelector(".cart_drawer_progress_bar");
							if (!cartBar) return;

							const maxAmountPrice = parseFloat(cartBar.getAttribute("data-maxamt"));
							const subTotalElem = document.getElementById('AjaxCartSubtotal')?.querySelector('.cart__total');
							const cartPrice = parseFloat(subTotalElem?.getAttribute("data-total-price")?.replace(/,/g, '').trim() || 0);

							const allSteps = mainProgressWrapper.querySelectorAll(".progbar_counter");
							if (!allSteps.length) return;

                            allSteps.forEach((step, index) => {
								const stepAmount = parseFloat(step.getAttribute("data-amount"));
								if (isNaN(stepAmount) || maxAmountPrice <= 0) return;

								step.style.left = Math.round((stepAmount / maxAmountPrice) * 100) + "%";

								const productElem = step.querySelector(".product_or_discount");
								if (!productElem) return;

								const type = productElem.getAttribute("data-product-or-discount");
								const wrapperId = `cart_drawer_free_product_wrapper_step_${index}`;

                                const productIdOnly = productElem.querySelector('.cart_free_product_wrapper')?.getAttribute("data-product-id");

                                // IF (cartPrice >= stepAmount)

                                if (cartPrice >= stepAmount && type === "product") {

                                    // Check ANY variant of the same product
                                    const hasFreeItem = cart.items.some(item => {
                                        return item.product_id.toString() === productIdOnly.toString() && Number(item.price) === 0;
                                    });

                                    // If ANY variant exists → do NOT render
                                    const shouldRender = !hasFreeItem;

                                    if (shouldRender) {
                                        allProductsHTML += `
                                            <div class="single_step_product_wrapper" id="${wrapperId}">
                                                <div class="free_product_wrapper_inner">
                                                    ${productElem.innerHTML}
                                                </div>
                                            </div>`;
                                    }
                                }
                                else {
                                        // 1. Remove accordion HTML
                                        const mainAccordion = document.querySelector('.main_free_product_accordion_wrapper');
                                        if (mainAccordion) {
                                            const productWrapper = mainAccordion.querySelector(`#${wrapperId}`);
                                            if (productWrapper) productWrapper.remove();
                                        }
                                        // 2. Remove only free variant from cart
                                        if (type === "product") {
                                            const matchedItems = cart.items.filter(item => {
                                                return item.product_id.toString() === productIdOnly.toString();
                                            });
                                            matchedItems.forEach(item => {
                                                if (Number(item.price) === 0) {
                                                    removeProductFromCart(item.variant_id);
                                                } else {
                                                    // console.log("Keeping paid variant:", item.variant_id);
                                                }
                                            });
                                        }
                                    }

                            });

                            let sidebarWrapper = document.querySelector('.sidebar__free_product_wrapper');

                            let cartPageWrapper = document.querySelector('.cart-form__items .sidebar__free_product_wrapper');

                            if (!cartPageWrapper && document.body.classList.contains('template-cart')) {
                                const cartItemsWrapper = document.querySelector('.cart-form__items');
                                if (cartItemsWrapper) {
                                    cartPageWrapper = document.createElement('div');
                                    cartPageWrapper.classList.add('sidebar__free_product_wrapper');
                                    cartItemsWrapper.appendChild(cartPageWrapper);
                                }
                            }

                            if (cartPageWrapper) {
                                cartPageWrapper.innerHTML = '';
                                cartPageWrapper.classList.remove('hideWrapper');

                                if (allProductsHTML.trim() !== '') {
                                    const wrapper = document.createElement('div');
                                    wrapper.classList.add('main_free_product_accordion_wrapper');
                                    wrapper.innerHTML = `
                                        <div class="headerItg active" style="cursor:pointer; display:flex; justify-content:space-between; align-items:center;">
                                            <span class="productTitleItg">Free Gift</span>
                                            <span class="svg-wrapper accordion_down_icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                                                    <path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/>
                                                </svg>
                                            </span>
                                        </div>
                                        <div class="free_product_wrapper" style="display:block;">
                                            <div class="free_product_inner_container">
                                                ${allProductsHTML}
                                            </div>
                                        </div>
                                    `;

                                    wrapper.querySelector('.headerItg').addEventListener('click', () => {
                                        const content = wrapper.querySelector('.free_product_wrapper');
                                        content.style.display = content.style.display === 'block' ? 'none' : 'block';
                                    });

                                    cartPageWrapper.appendChild(wrapper);
                                } else {
                                    cartPageWrapper.classList.add('hideWrapper');
                                }
                            }

							// CART DRAWER: clear previous content
							if (sidebarWrapper) {
								sidebarWrapper.innerHTML = '';
							}
						
							// Only build accordion if there are products
							if (allProductsHTML.trim() !== '') {
								const wrapper = document.createElement('div');
								wrapper.classList.add('main_free_product_accordion_wrapper');
								wrapper.innerHTML = `
									<div class="headerItg active" style="cursor:pointer; display:flex; justify-content:space-between; align-items:center;">
										<span class="productTitleItg">Free Gift</span>
										<span class="svg-wrapper accordion_down_icon">
											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
												<path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/>
											</svg>
										</span>
									</div>
									<div class="free_product_wrapper" style="display:block;">
										<div class="free_product_inner_container">
											${allProductsHTML}
										</div>
									</div>
								`;

								// Toggle accordion
								wrapper.querySelector('.headerItg').addEventListener('click', () => {
									const content = wrapper.querySelector('.free_product_wrapper');
									content.style.display = content.style.display === 'block' ? 'none' : 'block';
								});

								sidebarWrapper.appendChild(wrapper);
							} else {
								sidebarWrapper.classList.add('hideWrapper');
							}
						})();

						// Filled bar
						if (!isNaN(cartPrice)) {
							let filledPercent = ((cartPrice * 100) / maxAmountPrice);
							filledPercent = Math.min(Math.max(filledPercent, 0), 100);

							const filledBar = cartBar.querySelector(".cart_drawer_filled_bar");
							if (filledBar) {
								filledBar.style.width = filledPercent + "%";

							}
						}

						// subtotalAmt Updated

						// console.log(subTotalAmt);
						document.querySelector('.cart_drawer_progress_bar').setAttribute("data-cart-price" , subTotalAmt ) ;
						localStorage.setItem('loadedCartPrice', subTotalAmt);

					// removeProductFromCart  function //

					async function removeProductFromCart(productVariantId) {
						try {
							const lineItemElem = document.querySelector(`#item-${productVariantId}`);

							if (lineItemElem) {
								const removeBtn = lineItemElem.querySelector('a.remove, button.remove');

								if (removeBtn) {
									removeBtn.click(); // trigger click on the remove button
									// await updateCartDrawer() ;

								} else {
									console.warn(`Remove button not found for variant ${productVariantId}`);
								}
							} else {
								console.warn(`Line item not found in DOM for variant ${productVariantId}`);
							}
						} catch (err) {
							console.error(`Error removing variant ${productVariantId}:`, err);
						}
					}	
    }

    function updateCartQty(item, newQty){

        let alert = null;
        document.getElementById('AjaxCartForm').classList.add('processing');
        if ( document.getElementById('AjaxCartForm').querySelector('.alert') ) {
            document.getElementById('AjaxCartForm').querySelector('.alert').remove();
        }

        const body = JSON.stringify({
            line: parseInt(item.dataset.line),
            quantity: newQty
        });

        fetch(KROWN.settings.routes.cart_change_url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
                body
            })
            .then(response => response.json())
            .then(response => {
                if ( response.status == 422 ) {
                    // wrong stock logic alert
                    alert = document.createElement('span');
                    alert.classList.add('alert', 'alert--error');
                    if ( typeof response.description === 'string' ) {
                        alert.innerHTML = response.description;
                    } else {
                        alert.innerHTML = response.message;
                    }
                }
                return fetch('?section_id=helper-cart');
            })
            .then(response => response.text())
            .then(text => {

                const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
                const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
                const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

                const cartItems = document.getElementById('AjaxCartForm');
                cartItems.innerHTML = cartFormInnerHTML;
                rebindAjaxCartForm(cartItems);

                document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
                    elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
                });
                document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
                    elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
                });

                if ( alert !== null ) {	
                    document.getElementById('AjaxCartForm').prepend(alert);
                } 

                document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
                newUpdateCartDrawer() ;
                triggerAvailabilityRefresh({ forceReset: true, delay: 220 });

                const event = new Event('cart-updated');
                document.getElementById('AjaxCartForm').dispatchEvent(event);

            })
            .catch(e => {
                console.log(e);
                let alert = document.createElement('span');
                alert.classList.add('alert', 'alert--error');
                alert.textContent = KROWN.settings.locales.cart_general_error;
                document.getElementById('AjaxCartForm').prepend(alert);
            })
            .finally(() => {
                document.getElementById('AjaxCartForm').classList.remove('processing');
            });
    }

    function ajaxifyCartItems(cartItemsContainer) {
        cartItemsContainer.querySelectorAll('[data-js-cart-item]').forEach(item => {
            const remove = item.querySelector('.remove');
            if (remove) {       
                remove.dataset.href = remove.getAttribute('href');
                remove.setAttribute('href', '');
                remove.addEventListener('click', (e) => {
                    e.preventDefault();
                    updateCartQty(item, 0);
  
                });
            }

        });
    }

    function rebindAjaxCartForm(cartItemsContainer) {
        if (!cartItemsContainer) return;

        if (typeof cartItemsContainer.ajaxifyCartItems === 'function') {
            cartItemsContainer.ajaxifyCartItems();
        } else if (typeof ajaxifyCartItems === 'function') {
            ajaxifyCartItems(cartItemsContainer);
        }
    }

    function triggerAvailabilityRefresh(options) {
        if (
            typeof window !== 'undefined' &&
            typeof window.itgScheduleAvailabilityRefresh === 'function'
        ) {
            window.itgScheduleAvailabilityRefresh(options);
        }
    }

    async function addProductToCart(productVariantId, quantity = 1) {
        try {

                const properties = {
                   _free_product: 0  
                };

                await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: productVariantId,
                        quantity,
                        properties
                    })
                });

                await updateCartDrawer();
                await updateProgressBar(); 

                // updateCartContents({ showOverlay: true });

                fetch('?section_id=helper-cart')
                    .then((response) => response.text())
                    .then((text) => {

                        // console.log("inside modified fetch") ;
                        const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
                        const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;

                        const cartItems = document.getElementById('AjaxCartForm');
                        cartItems.innerHTML = cartFormInnerHTML;
                        rebindAjaxCartForm(cartItems);

                        document
                            .querySelectorAll('[data-header-cart-count]')
                            .forEach((element) => {
                                element.textContent = document.querySelector(
                                    '#AjaxCartForm [data-cart-count]'
                                ).textContent
                            })
                        document
                            .querySelectorAll('[data-header-cart-total]')
                            .forEach((element) => {
                                element.textContent = document.querySelector(
                                    '#AjaxCartForm [data-cart-total]'
                                ).textContent
                            })

                        triggerAvailabilityRefresh({ forceReset: true, delay: 260 });

                    })
                    .catch((error) => {
                        console.error('Error updating cart contents:', error)
                    })
            } catch (err) {
                console.error(`Error adding variant ${productVariantId}:`, err);
            }
        }


    async function updateCartDrawer() {
            // console.log("updateCartDrawer functions called") ;
            try {
                const response = await fetch('?section_id=helper-cart');
                const text = await response.text();

                const parser = new DOMParser();
                const doc = parser.parseFromString(text, 'text/html');

                const cartForm = doc.getElementById('AjaxCartForm').innerHTML;
                const cartSubtotal = doc.getElementById('AjaxCartSubtotal').innerHTML;

                const cartItems = document.getElementById('AjaxCartForm');
                cartItems.innerHTML = cartForm;
                rebindAjaxCartForm(cartItems);
                document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotal;

                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = cartSubtotal;

                const cartTotalElem = tempDiv.querySelector(".cart__total");
                const cartTotalNew = cartTotalElem ? cartTotalElem.getAttribute("data-total-price") : 0;

                // console.log(cartTotalNew);

                document.querySelector('.cart_drawer_progress_bar').setAttribute("data-cart-price" , cartTotalNew) ;
                localStorage.setItem('loadedCartPrice', cartTotalNew);

                const cartCount = doc.querySelector('#AjaxCartForm [data-cart-count]').textContent;
                document.querySelectorAll('[data-header-cart-count]').forEach(element => {
                    element.textContent = cartCount;
                });

                const cartTotal = doc.querySelector('#AjaxCartForm [data-cart-total]').textContent;
                document.querySelectorAll('[data-header-cart-total]').forEach(element => {
                    element.textContent = cartTotal;
                });

                triggerAvailabilityRefresh({ forceReset: true, delay: 260 });

            } catch (error) {
                console.error('Error updating cart contents:', error);
            }
            if (typeof window !== 'undefined' && window.__INTERNAL_TEST_MODE__) {
                newUpdateCartDrawer();
            } else {
                setTimeout(()=>{
                    newUpdateCartDrawer() ;
                },1000) ;
            }
    }

    async function removeProductFromCart(productVariantId) {
        try {
            // Target the line item div by variantId
            const lineItemElem = document.querySelector(`#item-${productVariantId}`);

            if (lineItemElem) {
                // Find the remove button inside this line item
                const removeBtn = lineItemElem.querySelector('a.remove, button.remove');

                if (removeBtn) {
                    removeBtn.click(); // trigger click on the remove button
                    await updateCartDrawer() ;
                } else {
                    console.warn(`Remove button not found for variant ${productVariantId}`);
                }
            } else {
                console.warn(`Line item not found in DOM for variant ${productVariantId}`);
            }
        } catch (err) {
            console.error(`Error removing variant ${productVariantId}:`, err);
        }
    }

async function updateProgressBar() {

    const main_progress_wrapper = document.querySelector('.cart_drawer_progress_bar_inner_wrapper');
    if (!main_progress_wrapper) return;

    const cartBar = main_progress_wrapper.querySelector(".cart_drawer_progress_bar");
    const maxAmountPrice = parseFloat(cartBar?.getAttribute("data-maxamt"));
    const cartPrice = parseFloat(cartBar?.getAttribute("data-cart-price"));

    if (isNaN(maxAmountPrice) || isNaN(cartPrice)) return;

    localStorage.setItem('loadedCartPrice', cartPrice);

    const allSteps = main_progress_wrapper.querySelectorAll(".progbar_counter");

    // Fetch current cart once
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    // Filled bar
    const filledBar = cartBar.querySelector(".cart_drawer_filled_bar");
    if (filledBar && maxAmountPrice > 0) {
        let filledPercent = ((cartPrice * 100) / maxAmountPrice);
        filledPercent = Math.min(Math.max(filledPercent, 0), 100);
        filledBar.style.width = filledPercent + "%";
    }

     let allProductsHTML = '';

    allSteps.forEach((step, index) => {
        const stepAmount = parseFloat(step.getAttribute("data-amount"));
        if (isNaN(stepAmount) || maxAmountPrice <= 0) return;

        step.style.left = Math.round((stepAmount / maxAmountPrice) * 100) + "%";

        const productElem = step.querySelector(".product_or_discount");
        if (!productElem) return;

        const type = productElem.getAttribute("data-product-or-discount");
        const wrapperId = `cart_drawer_free_product_wrapper_step_${index}`;
        const productIdOnly = productElem.querySelector('.cart_free_product_wrapper')?.getAttribute("data-product-id");
        // IF (cartPrice >= stepAmount)

        if (cartPrice >= stepAmount && type === "product") {

            // Check ANY variant of the same product
            const hasFreeItem = cart.items.some(item => {
                return item.product_id.toString() === productIdOnly.toString() && Number(item.price) === 0;
            });

            // If ANY variant exists → do NOT render
            const shouldRender = !hasFreeItem;

            if (shouldRender) {
                allProductsHTML += `
                    <div class="single_step_product_wrapper" id="${wrapperId}">
                        <div class="free_product_wrapper_inner">
                            ${productElem.innerHTML}
                        </div>
                    </div>`;
            }
        }
        else {
                // 1. Remove accordion HTML
                const mainAccordion = document.querySelector('.main_free_product_accordion_wrapper');
                if (mainAccordion) {
                    const productWrapper = mainAccordion.querySelector(`#${wrapperId}`);
                    if (productWrapper) productWrapper.remove();
                }
                // 2. Remove only free variant from cart
                if (type === "product") {
                    const matchedItems = cart.items.filter(item => {
                        return item.product_id.toString() === productIdOnly.toString();
                    });
                    matchedItems.forEach(item => {
                        if (Number(item.price) === 0) {
                            removeProductFromCart(item.variant_id);
                        } else {
                            // console.log("Keeping paid variant:", item.variant_id);
                        }
                    });
                }
            }

        });

            let sidebarWrapper = document.querySelector('.sidebar__free_product_wrapper');
            let cartPageWrapper = document.querySelector('.cart-form__items .sidebar__free_product_wrapper');

            if (!cartPageWrapper && document.body.classList.contains('template-cart')) {
                const cartItemsWrapper = document.querySelector('.cart-form__items');
                if (cartItemsWrapper) {
                    cartPageWrapper = document.createElement('div');
                    cartPageWrapper.classList.add('sidebar__free_product_wrapper');
                    cartItemsWrapper.appendChild(cartPageWrapper);
                }
            }

            if (cartPageWrapper) {
                cartPageWrapper.innerHTML = '';
                cartPageWrapper.classList.remove('hideWrapper');

                if (allProductsHTML.trim() !== '') {
                    const wrapper = document.createElement('div');
                    wrapper.classList.add('main_free_product_accordion_wrapper');
                    wrapper.innerHTML = `
                        <div class="headerItg active" style="cursor:pointer; display:flex; justify-content:space-between; align-items:center;">
                            <span class="productTitleItg">Free Gift</span>
                            <span class="svg-wrapper accordion_down_icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                                    <path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/>
                                </svg>
                            </span>
                        </div>
                        <div class="free_product_wrapper" style="display:block;">
                            <div class="free_product_inner_container">
                                ${allProductsHTML}
                            </div>
                        </div>
                    `;

                    wrapper.querySelector('.headerItg').addEventListener('click', () => {
                        const content = wrapper.querySelector('.free_product_wrapper');
                        content.style.display = content.style.display === 'block' ? 'none' : 'block';
                    });

                    cartPageWrapper.appendChild(wrapper);
                } else {
                    cartPageWrapper.classList.add('hideWrapper');
                }
            }

            // CART DRAWER: clear previous content
            if (sidebarWrapper) {
                sidebarWrapper.innerHTML = '';
            }

            // Only build accordion if there are products
            if (allProductsHTML.trim() !== '') {
                const wrapper = document.createElement('div');
                wrapper.classList.add('main_free_product_accordion_wrapper');
                wrapper.innerHTML = `
                    <div class="headerItg active" style="cursor:pointer; display:flex; justify-content:space-between; align-items:center;">
                        <span class="productTitleItg">Free Gift</span>
                        <span class="svg-wrapper accordion_down_icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                                <path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/>
                            </svg>
                        </span>
                    </div>
                    <div class="free_product_wrapper" style="display:block;">
                        <div class="free_product_inner_container">
                            ${allProductsHTML}
                        </div>
                    </div>
                `;

                // Toggle accordion
                wrapper.querySelector('.headerItg').addEventListener('click', () => {
                    const content = wrapper.querySelector('.free_product_wrapper');
                    content.style.display = content.style.display === 'block' ? 'none' : 'block';
                });
                sidebarWrapper.appendChild(wrapper);
            } else {
                sidebarWrapper.classList.add('hideWrapper');
            }
}
